<template>
	<div class="col-lg-6">
		<h4 class="section-h4">Your Order</h4>
		<div class="order-table">
			<table class="u-s-m-b-13">
				<thead>
					<tr>
						<th>Product</th>
						<th>Total</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="cart in getCarts" :key="cart.id">
						<td>
							<h6 class="order-h6">{{ cart.product.product_name }}</h6>
							<span class="order-span-quantity"> x {{ cart.qty }}</span>
						</td>
						<td>
							<h6 class="order-h6">{{ formatCurrency(cart.total_price) }}</h6>
						</td>
					</tr>
					<tr v-if="coupon">
						<td>
							<h6 class="order-h6">Discount (Code : {{ coupon.code }})</h6>
						</td>
						<td>
							<h6 class="order-h6">-&nbsp;{{ formatCurrency(coupon.amount) }}</h6>
						</td>
					</tr>
					<tr>
						<td>
							<h6 class="order-h6">Tax</h6>
						</td>
						<td v-if="warehouse_state == billing_state">
							<h6 class="order-h6">
								<div>{{ formatCurrency(getTax / 2) }} <small>CGST</small></div>
								<div>{{ formatCurrency(getTax / 2) }} <small>SGST</small></div>
							</h6>
						</td>
						<td v-else>
							<h6 class="order-h6">
								<div>{{ formatCurrency(getTax) }}</div>
							</h6>
						</td>
					</tr>
					<tr>
						<td>
							<h6 class="order-h6">Delivery Fee</h6>
						</td>
						<td>
							<h6 class="order-h6">{{ formatCurrency(delivery_fee) }}</h6>
						</td>
					</tr>
					<tr>
						<td>
							<h6 class="order-h6">Total</h6>
						</td>
						<td>
							<h6 class="order-h6">{{ formatCurrency(getTotal) }}</h6>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="u-s-m-b-13">
				<label for="postcode-extra"
					>Time Slot
					<span class="astk">*</span>
				</label>
				<select class="form-control" v-model="form.slot">
					<option value="" selected>Select Time Slot</option>
					<option
						:value="timeSlot"
						v-for="(timeSlot, index) in createTimeSlotDropdown"
						:key="index"
					>
						{{ timeSlot }}
					</option>
				</select>
			</div>
			<div class="u-s-m-b-13">
				<input
					type="radio"
					class="radio-box"
					name="payment-method"
					id="card"
					value="card"
					v-model="form.payment_method"
				/>
				<label class="label-text" for="card">Credit/Debit Card/Net Banking</label>
			</div>
			<div class="u-s-m-b-13">
				<input
					type="checkbox"
					class="check-box"
					id="accept"
					ref="tandc_check"
					v-model="form.tnc"
				/>
				<label class="label-text no-color order_t_c" for="accept"
					>I’ve read and accepted the
					<router-link
						:to="{name: 'TermsAndConditions', query: {type: 'checkout'}}"
						class="u-c-brand"
						>terms &amp; conditions</router-link
					>
				</label>
			</div>
			<button
				@click.prevent="handlePlaceOrder"
				type="submit"
				class="button button-outline-secondary"
			>
				{{ form.payment_method == "cod" ? "Place Order" : "Proceed to payment" }}
			</button>
		</div>
	</div>
</template>

<script>
	import {formatCurrency} from "../../utils/common_functions";
	import {useToast} from "vue-toastification";
	export default {
		props: [
			"getCarts",
			"getTax",
			"getTotal",
			"coupon",
			"delivery_fee",
			"billing_state",
			"warehouse_state",
		],
		computed: {
			createTimeSlotDropdown() {
				let startTime = 7;
				let t = "am";
				let timeSlotsArray = [];
				for (let index = 0; index <= 13; index++) {
					let data = `${startTime}:00${t} - `;
					startTime++;
					if (startTime == 12) {
						t = "pm";
					} else if (startTime == 13) {
						startTime = 1;
					}
					data += `${startTime}:00${t}`;
					timeSlotsArray.push(data);
				}
				return timeSlotsArray;
			},
		},
		data() {
			return {
				form: {
					payment_method: "card",
					tnc: false,
					slot: "11:00am - 12:00pm",
				},
			};
		},
		methods: {
			formatCurrency,
			handlePlaceOrder() {
				if (!this.form.payment_method) {
					useToast().error("Please select payment option", {
						timeout: 3000,
					});
				} else if (!this.form.tnc) {
					useToast().error("Please accept Term's & Condition", {timeout: 3000});
				} else if (!this.form.slot) {
					useToast().error("Please Select Time Slot", {timeout: 3000});
				} else {
					this.$emit("PlaceOrder", this.form);
				}
			},
		},
	};
</script>

<style>
@media (max-width: 440px){
  .order_t_c{
	font-size: 10px !important;
  }
}

</style>
